import { PaymentPartnerKind } from '@/constants';
import MainContent from '@/layouts/MainContent';
import { Tabs } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import PartnerAccount from './items/PartnerAccount';
import UtilityPartner from './items/UtilityPartner';
const PAGE_TITLE = 'partnerPage_Title';

export default function PartnersPage() {
  const { t } = useTranslation();

  return (
    <MainContent title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <Tabs>
          <Tabs.TabPane tab={t('partnerPage_MNOS')} key="mnos">
            <PartnerAccount partnerType={PaymentPartnerKind.MNO} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('partnerPage_Bank')} key="bank">
            <PartnerAccount partnerType={PaymentPartnerKind.Bank} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('partnerPage_Utility')} key="utility">
            <UtilityPartner />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </MainContent>
  );
}
